export default {
	total_contato:0,
	total_procedimento:0,
  logged:null,
}



// WEBPACK FOOTER //
// ./src/store/credenciada/state.js